import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeedbackIconMobile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 48,
	viewBox: "0 0 52 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M52 48H24C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0H52V48Z",
			fill: "#008282"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.4688 14.75C41.5733 14.75 42.4687 15.6454 42.4688 16.75V32.75C42.4687 33.8546 41.5733 34.75 40.4688 34.75H18.4688C17.3642 34.75 16.4688 33.8546 16.4688 32.75V16.75C16.4688 15.6454 17.3642 14.75 18.4688 14.75H40.4688Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8018 6.66016C16.0972 6.0901 16.9747 6.13123 17.1865 6.7832L18.3047 10.2236H21.9219C22.6531 10.2237 22.9569 11.159 22.3652 11.5889L19.4209 13.7266L20.2861 16.7822C20.4769 17.4561 19.7275 18.0044 19.1436 17.6182L16.4873 15.8584L13.542 18C12.9504 18.4295 12.1539 17.8508 12.3799 17.1553L13.4971 13.7148L10.5713 11.5889C9.97997 11.1589 10.2843 10.2236 11.0156 10.2236H14.6328L15.751 6.7832L15.8018 6.66016Z",
			fill: "#008282",
			stroke: "#008282",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.2686 20.5488H35.4686V22.1488H20.2686V20.5488Z",
			fill: "#008282"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.2686 24.2988H35.4686V25.8988H20.2686V24.2988Z",
			fill: "#008282"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.2686 28.2988H29.0686V29.8988H20.2686V28.2988Z",
			fill: "#008282"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2656 7.61035C16.3814 7.45602 16.6441 7.48185 16.7109 7.6875L17.7734 10.9551H21.209C21.4557 10.9554 21.5582 11.2709 21.3584 11.416L18.5791 13.4346L19.6406 16.7031C19.717 16.938 19.4479 17.1335 19.248 16.9883L16.4688 14.9678L13.6895 16.9883C13.4896 17.1335 13.2205 16.9381 13.2969 16.7031L14.3574 13.4346L11.5791 11.416C11.3794 11.2709 11.4817 10.9554 11.7285 10.9551H15.1641L16.2266 7.6875L16.2656 7.61035Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 33V39.5C35 39.9805 34.3879 40.1842 34.0996 39.7998L29 33H35Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgFeedbackIconMobile);
export { ForwardRef as ReactComponent };
